export default __webpack_public_path__ + "static/IMDA-SME-Go-Digital-Day-8ebb5555a149bf0caa341775255664ba.png";